<template>
  <div class="search__input">
    <span class="icon" v-on:click.prevent="resultsPage">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18 17"
        width="20"
        height="20"
      >
        <g fill="none" stroke="#00afd7" stroke-width="1.5">
          <circle cx="7" cy="7" r="6.3"></circle>
          <path stroke-linecap="square" d="M12.5 11.5l4 4"></path>
        </g>
      </svg>
    </span>

    <input
      type="text"
      v-bind:value="value"
      v-on:input="emitValue($event.target.value)"
      v-on:focus="emitFocus()"
      v-on:keyup.enter="resultsPage"
      :placeholder="translations.searchPlaceholder"
    />
    <span class="clear" v-on:click.prevent="clearSearchResult">✕</span>
  </div>
</template>

<script>
export default {
  name: 'ProductSearch',
  data() {
    return {
      translations: {
        searchPlaceholder: ws_vue_store.translations.search_placeholder,
      },
    };
  },
  props: {
    value: String,
  },

  methods: {
    resultsPage() {
      if (!this.value) return;

      let archive = this.$router.resolve({ name: 'Archive' });
      let langParam = '';
      if (window.location.href.includes('lang=en')) {
        langParam = '&lang=en';
      }
      if (window.location.href.includes('lang=fi')) {
        langParam = '&lang=fi';
      }
      if (window.location.href.includes('lang=ru')) {
        langParam = '&lang=ru';
      }
      console.log(window.location.href);
      console.log(langParam);
      window.location.href =
        archive.href + '?search_term=' + this.value + langParam;
      return;
    },
    clearSearchResult() {
      // If on search result page then redirect out of search page
      if (this.$route.query && this.$route.query.search_term) {
        window.location.href = this.$router.resolve({ name: 'Archive' }).href;
      }
      this.emitValue(''); // Clear search field
    },
    emitValue(value) {
      this.$emit('input', value);
    },
    emitFocus() {
      this.$emit('focus');
    },
  },
};
</script>

<style scoped lang="scss">
.search {
  &__input {
    position: relative;
    display: flex;
    align-items: center;
    background-color: $color-white;
    align-items: center;

    input {
      width: 100%;
      padding: 1.5rem 4rem 1.5rem 1rem;

      &:not(:placeholder-shown) {
        border-color: $color-black;
      }

      &::placeholder {
        color: #a2a2a2;
        font-size: inherit;
      }
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem 2rem;
      position: relative;
      cursor: pointer;
    }

    .clear {
      position: relative;
      right: 0;
      padding: 1rem;
      color: #cecece;
      font-size: 1.3rem;
      vertical-align: middle;
      cursor: pointer;
      align-self: center;
    }

    &.error {
      svg g {
        stroke: $color-error;
      }

      input {
        border-color: $color-error;

        &,
        &::placeholder {
          color: $color-error;
        }
      }

      .clear {
        color: $color-error;
      }
    }
  }
}
</style>
